module.exports = __webpack_public_path__ + "img/majoras-mask.39fa5a0a.jpg";